module.exports = __webpack_public_path__ + "static/img/metal.8fdf793.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/construction/metal.gif
// module id = 3OGz
// module chunks = 0